import { DataSource, Image, Layout, Panel, Tab, Table, Tabset, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutTariffRegionMaster extends Layout {
    imageAddZipCodeRegion: Image;
    panelLocSecondaryFilters: Panel;
    panelZipSecondaryFilters: Panel;
    sourceTariffRegionLoc: DataSource;
    sourceTariffRegionLtlZipLoc: DataSource;
    sourceTariffRegionZip: DataSource;
    tabGeneral: Tab;
    tabLocations: Tab;
    tabZipCodes: Tab;
    tableLocations: Table;
    tableZipCodes: Table;
    tabsetGeneral: Tabset;
    textboxRegionName: Textbox;
    textboxRegionNickname: Textbox;
}
